import datashipsLogoGradient from "@/assets/svgs/dataships-logo-gradient.svg";
import datashipsLogoXmas from "@/assets/svgs/dataships-logo-xmas-dark.svg";
import { checkIsChristmas } from "@/utils/helpers";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "absolute inset-x-0 inset-y-0 flex h-screen w-screen flex-col items-center justify-start gap-40 bg-white pt-64 text-secondary",
    pulsingLogo: "h-55",
  },
});

const SplashScreen = () => {
  const { base, pulsingLogo } = styles();
  const isChristmas = checkIsChristmas();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const logo = isChristmas ? datashipsLogoXmas : datashipsLogoGradient;

  return (
    <div className={base()} data-testid="splash-screen">
      <img
        src={logo}
        alt="Dataships Logo"
        width={300}
        className={pulsingLogo()}
      />
      <FontAwesomeIcon icon={faSpinnerThird} className="h-50 text-primary" spin />
    </div>
  );
};

export default SplashScreen;
